import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import Nav from '@mc/navigation'
import { i18nInstance } from '../../i18n'
import classes from './TopNavigation.module.scss'

export interface TopNavigationProps {
  as?: 'div' | 'nav'
  contained?: boolean
  className?: string
  children?: React.ReactNode
}

const TopNavigationShell = ({
  as = 'div',
  contained = false,
  className = '',
  children,
}: TopNavigationProps) => {
  const { t } = useTranslation('@mc/global-navigation')

  return (
    <Nav
      as={as}
      aria-label={as === 'nav' ? t('nav.utility.label') : undefined}
      background='transparent'
      className={`mc-bg-neutral-1000 d-none d-lg-block mc-theme-dark mc-py-1 ${className}`}
      navChildClassName={`flex-nowrap ${classes.navChild}`}
      contained={contained}
    >
      <Nav.Left>{children}</Nav.Left>
    </Nav>
  )
}

export const TopNavigation = withI18nContext(i18nInstance)(TopNavigationShell)
